export default __webpack_public_path__ + "img/pin-grey.1785b299.svg";